import React from "react";
import { Link } from "react-router-dom";

/* ─── Advertisement Banner ─────────────────────────────────────── */
const AdvertisementBanner = () => (
  <section className="relative w-full overflow-hidden" style={{ minHeight: "300px" }}>
    {/* Background Image */}
    <img
      src="https://images.unsplash.com/photo-1555939594-58d7cb561ad1?q=80&w=1800&auto=format&fit=crop"
      alt="Barbequeen smoked BBQ experience"
      className="absolute inset-0 w-full h-full object-cover object-center"
      aria-hidden="true"
    />

    {/* Dark overlay */}
    <div className="absolute inset-0 bg-black/65" />

    {/* Content */}
    <div className="relative z-10 max-w-[1280px] mx-auto px-4 lg:px-8 py-16 sm:py-20">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center">

        {/* ── Left: Heading ── */}
        <div>
          <p className="font-sans text-[11px] font-semibold tracking-[0.3em] text-gray-300 uppercase mb-4">
            Get Started
          </p>
          <h2 className="text-[34px] sm:text-[44px] lg:text-[50px] font-bold text-white leading-tight uppercase tracking-wide">
            Create Memorable
            <br />
            Dining Moments
          </h2>
        </div>

        {/* ── Right: Description + CTA ── */}
        <div className="flex flex-col items-start gap-6">
          <p className="font-sans text-[14px] text-gray-300 leading-relaxed max-w-sm">
            Experience the rich aroma of slow-smoked meats, hand-crafted dry rubs, and 
            authentic pit-fired flavours at Barbequeen — where every meal becomes an 
            unforgettable celebration.
          </p>
          <Link
            to="/menu"
            className="font-sans inline-flex items-center gap-2 px-7 py-3 bg-[#9b1c2e] hover:bg-[#7d1624] text-white text-[12px] font-bold tracking-[0.2em] uppercase transition-all duration-200 hover:gap-4"
          >
            Learn More
            <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M17 8l4 4m0 0l-4 4m4-4H3" />
            </svg>
          </Link>
        </div>

      </div>
    </div>
  </section>
);

export default AdvertisementBanner;

